import { Component, OnInit, Input, ViewChild } from '@angular/core';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less']
})
export class LoaderComponent implements OnInit {
  loading = false;
  headerHeight = 0;

  @ViewChild('loader') loader;
  loaderHeight: 0;

  @Input()
  size = '';

  constructor() { }

  ngOnInit(): void {
  }


}
